var _path, _path2, _rect, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVipIconMegaflirt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.302 12.244l.14.102-10.884 7.964-.14-.102 10.884-7.964zm0-.613L12.42 3.667a.754.754 0 00-.838 0L.698 11.63c-.232.17-.232.444 0 .613l10.883 7.964c.232.17.606.17.838 0l.14.102a1.005 1.005 0 01-1.117 0L.558 12.346C.26 12.127.25 11.777.53 11.55l.028-.022 10.884-7.964.03-.02c.31-.206.787-.199 1.086.02l10.884 7.964.028.022c.28.226.27.576-.028.795l-.14-.102c.232-.17.232-.444 0-.613z",
    fill: "var(--cta, #FA4568)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.85 12.204l.122.09-9.486 6.94-.122-.088 9.486-6.942zm0-.534l-9.486-6.94a.657.657 0 00-.73 0L2.15 11.67c-.201.148-.201.387 0 .534l9.486 6.942a.657.657 0 00.73 0l.121.089a.876.876 0 01-.973 0l-9.486-6.941c-.26-.191-.268-.496-.024-.694l.024-.018 9.486-6.942.026-.018a.88.88 0 01.947.018l9.486 6.942.024.018c.244.198.236.503-.024.694l-.122-.09c.202-.147.202-.386 0-.534z",
    fill: "var(--cta, #FA4568)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.48,
    y: 8.388,
    width: 20.917,
    height: 7.499,
    rx: 1.48,
    fill: "var(--sections, white)",
    stroke: "var(--cta, #FA4568)",
    strokeWidth: 0.197
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.406 9.867h1.191v4.736h-1.191V9.867zm-1.808 0h1.266l-1.78 4.715H7.897L6.117 9.867h1.264l1.108 3.027 1.11-3.027zm5.381 3.552v1.184h-1.191V9.867h2.382c.474 0 .929.187 1.264.52a1.77 1.77 0 010 2.512c-.335.333-.79.52-1.264.52h-1.19zm0-2.368v1.184h1.192a.598.598 0 00.595-.592.59.59 0 00-.595-.592h-1.192z",
    fill: "var(--cta, #FA4568)"
  })));
}
export default SvgVipIconMegaflirt;